<template>
  <transition :css="false" @leave="leave">
    <f7-page class="main-time-dimension">
      <div class="time-card">
        <!-- Submenú en la parte superior del card -->
        <div class="sub-menu-wrapper">
          <SubMenu
            :items="MenuOptions.contexts.samples.itemsByArea.agronomy"
          />
        </div>
        <!-- Aquí tu título principal -->
        <div class="summary-sidebar-header">
          <span class="summary-title-text">{{ farmStr }}</span>
        </div>
        <div class="content-devx">
          <div v-if="!loadedGIS" class="loadingFalse">
            <div class="preloader">
              <span class="preloader-inner">
                <span class="preloader-inner-circle"></span>
              </span>
            </div>
          </div>
          <div v-else>
            <f7-row>
              <f7-col>
                <GISWMSTimeDimensionMap
                  :zoom="zoom"
                  :name-map="mainMap"
                  :layer="layer"
                  :bbox="bbox"
                  :height="'540px'"
                />
              </f7-col>
              <f7-col>
                <div
                  class="display-flex align-items-flex-start justify-content-space-between"
                >
                  <DxForm label-location="top" class="custom-form">
                    <DxItem
                      :editor-options="{
                        items: indexes,
                        onValueChanged: onIndexChange,
                        value: selectedIndex,
                        valueExpr: 'key',
                        displayExpr: 'value',
                        placeholder: $t('select'),
                      }"
                      data-field=""
                      editor-type="dxSelectBox"
                    >
                      <DxLabel :text="$t('index')" />
                    </DxItem>
                  </DxForm>
                  <!-- <GisTimeDimensionDatePicker /> -->
                  <div class="custom-form">
                    <label
                      class="dx-field-item-label-text"
                      style="
                        display: inline-block;
                        margin-bottom: 5px;
                      "
                    >
                    </label>
                    <GisTimeDimensionDatePicker />
                  </div>
                </div>

                <div v-if="loadedTimeLine" class="margin-top">
                  <TimelineGraph
                    :timeline-indexes="timelineIndexes"
                    :index="selectedIndex"
                  />
                </div>
              </f7-col>
            </f7-row>
            <f7-row class="no-margin padding-top-half">
              <f7-col class="display-flex justify-content-flex-end">
                <DxButton
                  type="default"
                  :text="$t('comparative')"
                  @click="goToComparative"
                />
              </f7-col>
            </f7-row>
          </div>
        </div>
      </div>
    </f7-page>
  </transition>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/services/Api';
import GISWMSTimeDimensionMap from '@/components/Gis/WMSTimeDimension/index.vue';
import GisTimeDimensionDatePicker from '@/components/Gis/WMSTimeDimension/datePicker/index.vue';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import format from 'date-fns/format';
import moment from 'moment';
import TimelineGraph from '@/components/Gis/WMSTimeDimension/timeLineGraph/index.vue';
import EventBus from '@/services/event-bus';
import DxButton from 'devextreme-vue/button';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import MenuOptions from '@/json/menuOptions.json';
import SubMenu from '@/components/SubMenu/index.vue';

export default {
  name: 'TimeDimensionMapPage',
  components: {
    GISWMSTimeDimensionMap,
    GisTimeDimensionDatePicker,
    DxItem,
    DxLabel,
    DxForm,
    TimelineGraph,
    DxButton,
    SubMenu,
  },
  data() {
    return {
      loadedGIS: false,
      loadedTimeLine: false,
      zoom: 17,
      mainMap: 'GisTimeDimension',
      layer: {
        name: 'gis',
        visible: false,
        timeDimension: true,
        baseUrl: Api.getGeoServerProjectWorkSpace(),
        options: {
          layers: '',
          outputFormat: 'image/png',
          transparent: true,
          styles: 'NDVI',
        },
      },
      center: {},
      bbox: {},
      filteredTasks: null,
      ws: Api.getGeoServerWorkspace(),
      indexes: [{ key: 'NDVI', value: 'NDVI' }],
      selectedIndex: 'NDVI',
      MenuOptions,
    };
  },
  computed: {
    ...mapState('registerFarm', [
      'parcelId',
      'parcelGisId',
      'farmStr',
      'parcelStr',
    ]),
    ...mapState('gis', [
      'timelineIndexes',
      'currentBoundsWMSLayer',
      'currentInitIntervalDates',
      'currentEndIntervalDates',
      'selectedIndex',
    ]),
  },
  async beforeMount() {
    this.setSelectedIndex(this.selectedIndex);

    this.setCurrentRoute([
      {
        name: this.$t('Agronomy'),
        disabled: false,
        page: 'AgronomySamplesPage',
        active: false,
      },
      {
        name: this.$t('advancedServices'),
        disabled: false,
        page: 'AdvancedServicesPage',
        active: false,
      },
      {
        name: this.farmStr,
        disabled: false,
        page: 'DashboardPage',
        active: false,
      },
      // {
      //   name: this.$t('teledetection'),
      //   disabled: true,
      //   page: 'TimeDimensionMapPage',
      //   active: true,
      // },
      {
        name: this.parcelStr,
        disabled: true,
        page: 'TimeDimensionMapPage',
        active: true,
      },
    ]);
  },
  beforeDestroy() {
    EventBus.$off('updateTimeLineIndexes');
  },
  async mounted() {
    try {
      this.loadedGIS = false;
      this.setDates();
      if (!this.parcelId || this.parcelId === 'undefined') {
        console.warn(
          'Invalid parcelId in TimeDimensionMap:',
          this.parcelId
        );
        return;
      }

      const wmsLayerId = Api.normalizeGISLayerId(
        this.parcelGisId || this.parcelId
      );

      this.layer.options.layers = wmsLayerId;
      await this.boundsWMSLayer(`${this.ws}:${this.parcelId}`);
      this.bbox = {
        ...this.currentBoundsWMSLayer.coverage.latLonBoundingBox,
      };

      EventBus.$on(`updateTimeLineIndexes`, async () => {
        this.loadedTimeLine = false;
        await this.fetchTimelineIndexes({
          location: this.parcelId,
          initDate: moment(
            this.currentInitIntervalDates[this.mainMap]
          ).format('YYYY-MM-DD'),
          endDate: moment(
            this.currentEndIntervalDates[this.mainMap]
          ).format('YYYY-MM-DD'),
          index: this.selectedIndex,
        });
        this.loadedTimeLine = true;
      });
    } catch (e) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(e.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loadedGIS = true;
    }
  },
  methods: {
    onIndexChange(e) {
      this.selectedIndex = e.value;
    },
    goToComparative(e) {
      this.$f7router.navigate(
        {
          name: 'GisComparatorPage',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    formatDate(a, b) {
      return format(a, b);
    },
    leave() {
      const timeDimension = document.getElementsByClassName(
        'timecontrol-play'
      )[0];

      if (timeDimension) {
        const timeDimensionClassList = timeDimension.classList;
        if (timeDimensionClassList.contains('pause')) {
          timeDimension.click();
        }
      }
    },
    setDates() {
      const today = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
      this.setCurrentInitIntervalDates({
        key: this.mainMap,
        newCurrentInitIntervalDate: new Date(threeMonthsAgo),
      });
      this.setCurrentEndIntervalDates({
        key: this.mainMap,
        newCurrentEndIntervalDate: today,
      });
    },

    ...mapActions('breadcrumb', [
      'pushRoute',
      'replaceCurrent',
      'setCurrentRoute',
    ]),
    ...mapActions('gis', [
      'setCurrentIndexes',
      'setCurrentInitIntervalDates',
      'setCurrentEndIntervalDates',
      'fetchTimelineIndexes',
      'setTimelineIndexes',
      'boundsWMSLayer',
      'setSelectedIndex',
    ]),
  },
};
</script>
<style scoped>
:deep(.dx-selectbox.dx-texteditor.dx-editor-outlined) {
  border: 1px solid var(--Primary-Blue-70, #00346a) !important;
  border-radius: 10px !important;
  background: var(--Basic-White, #fff) !important;
  box-shadow: none !important;
  height: 40px;
}

.dx-texteditor.dx-editor-outlined {
  border-radius: none !important;
}

:deep(.input-clear-button) {
  right: 25px !important;
  top: 37% !important;
  transform: translateY(-50%) !important;
}

.summary-sidebar-header {
  margin-left: 10px; /* Ajusta este valor hasta alinear con el mapa */
  margin-bottom: 20px;
}
.sub-menu-wrapper {
  margin-bottom: 5px; /* O más si necesitas más separación */
}

/* Card blanco flotante (igual estilo que el otro) */
.time-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  margin: 24px 24px; /* margen exterior del card (ajústalo si quieres) */
  padding: 10px 28px; /* padding interno del card */
  box-sizing: border-box;
  height: 765px;
}

/* Alinea submenú y título a los laterales del card (sin sangrías extras) */
.time-card .sub-menu-wrapper,
.time-card .summary-sidebar-header {
  margin: 0 0 12px 0 !important;
  padding: 0 !important;
  width: 100%;
}

/* El bloque de contenido respeta el padding del card */
.time-card .content-devx {
  margin: 0 !important;
  width: 100%;
  box-sizing: border-box;
}

/* Quita fondo/scroll horizontal de la zona scrolleable de F7 */
:deep(.main-time-dimension .page-content) {
  background: transparent !important; /* el fondo lo pone el card */
  padding: 0 !important; /* sin padding adicional */
  overflow-x: hidden !important; /* adiós barra horizontal */
}

/* Previene desbordes de columnas/Leaflet que reactivan la barra */
:deep(.main-time-dimension .row),
:deep(.main-time-dimension .col),
:deep(.main-time-dimension .leaflet-container) {
  min-width: 0 !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

/* Responsive: card un poco más compacto en pantallas estrechas */
@media (max-width: 1200px) {
  .time-card {
    margin: 16px;
    padding: 18px 20px;
  }
}

.content-devx {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important; /* por si hereda fondo */
}

.time-card .sub-menu-wrapper,
.time-card .summary-sidebar-header {
  padding-left: 15px !important;
}
</style>
